export class InfoPlantUserModel {
    public userAuth: boolean;
    public id: string;
    public registrationDate: string;
    public firstName: string;
    public lastName: string;
    public job: string;
    public jobTrd: string;
    public email: string;
    public password: string;
    public phone: string;
    public companyName: string;
    public companyRole: string;
    public companyRoleTrd: string;
    public vat: string;
    public address: string;
    public city: string;
    public zip: string;
    public country: string;
    public type: string;

    constructor(value: JSON) {
        this.userAuth = value["user_auth"];
        const userObj = value["user"];
        if (userObj != null && userObj.length > 0) {
            const user = userObj[0];
            this.id = user["ID"];
            this.registrationDate = user["REG_DATE"];
            this.firstName = user["NAME"];
            this.lastName = user["SURNAME"];
            this.job = user["JOB"];
            this.jobTrd = user["JOB_TRD"];
            this.email = user["EMAIL"];
            this.password = user["PASS"];
            this.phone = user["PHONE"];
            this.companyName = user["COMP_NAME"];
            this.companyRole = user["COMP_ROLE"];
            this.companyRoleTrd = user["COMP_ROLE_TRD"];
            this.vat = user["VAT_FISC"];
            this.address = user["ADDRESS"];
            this.city = user["CITY"];
            this.zip = user["ZIP"];
            this.country = user["COUNTRY"];
            this.type = user["TYPE"];
        }
    }
}
